import script from "./RegistrationPht.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationPht.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationPht.vue?vue&type=style&index=0&id=7c505878&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c505878"]])

export default __exports__